export { ConfirmAccountComponent } from "./confirm-account.component";
